import { render, staticRenderFns } from "./VoucherSegmentClientListItemCode.vue?vue&type=template&id=b5fd54ac&scoped=true"
import script from "./VoucherSegmentClientListItemCode.vue?vue&type=script&lang=js"
export * from "./VoucherSegmentClientListItemCode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5fd54ac",
  null
  
)

export default component.exports